const cdnHosts = ['img.salonized.com', 'img.salonized-staging.io'];

// Host detection only; the backend is the only place a /generate/ path is composed.
export const isCdnSource = (value: string) => {
  if (!value.startsWith('https://')) {
    return false;
  }

  try {
    return cdnHosts.includes(new URL(value).hostname);
  } catch {
    return false;
  }
};
